var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-avatar"},[(_vm.avatarUrl)?_c('img',{attrs:{"src":_vm.avatarUrl,"alt":""}}):_c('div',{staticClass:"avatar-placeholder"},[_vm._v(" "+_vm._s(_vm.firstChar)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }